

<template>
  <div class="container mx-auto object-center">
	<!-- <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 place-items-center"> -->
  <div class="flex flex-col flex-wrap md:flex-col lg:flex-row gap-3 items-center lg:items-stretch object-center">
   
  </div><h1 class="font-semibold mx-8 my-4 text-center text-cyan-50 text-2xl leading-7">{{ data?.post?.title }}</h1>
    <section class="mx-6"><client-only>
      <p class="text-sky-200 text-base" v-html="data?.post?.content"></p>
    </client-only>
    </section><div>
	<!-- <p class="text-xl">There are {{ data }} ships.</p> -->
  </div></div>
</template>
  
<script lang="ts" setup>
import { ref } from 'vue'
//import gql from "graphql-tag";
import { useRoute } from 'vue-router';
//import { useAsyncQuery } from '@nuxtjs/apollo'

const  route = useRoute()
const  slug = ref('')
const { clients, getToken, onLogin, onLogout } = useApollo()
//const slug = params.slug as string;

type PostResults = {
  post:{
    guid: string,
      title: string,
      image: string,
      content: string,
      link: string
    
  }
}

const query = gql`
  query SinglePostBySlug ($slug: ID!) {
    post(id: $slug, idType: SLUG) {
      id
      title
      date
      content
  }}
  `

const { data } = await useAsyncQuery<PostResults>(query, {slug: route.params.slug})
// if (data.post === null) {
//   await navigateTo({path:'/'})
// }
//const postData = ref(null)

// if (data && data.value.post) {
//   postData?.value = data.value.post
// }
// console.log(data.value)
// console.log(data)
// console.log(slug)
// console.log(route.params.slug)
</script>
<style>
h2, h3, h4, h5, h6 {
  color: white
}

p, h2, h3, h4, h5, h6 {
  font-size: revert;
  font-weight: revert;
  margin: revert;
}
</style>